import React from 'react';
import Navbar from '../components/Navbar';
import PlatformFooter from '../components/PlatformFooter';

const MainLayout = ({ children }) => {
  return (
    <div className="app-wrapper">
      <Navbar />
      <main className="main-content">
        {children}
      </main>
      <PlatformFooter />
    </div>
  );
};

export default MainLayout;
